/**
 * SKU-aware search.
 *
 * Shopify's default search does not match on the SKU field. This script
 * intercepts search form submissions and rewrites the query so it also
 * checks variants.sku, using Shopify's documented field-search syntax
 * (see https://shopify.dev/docs/api/usage/search-syntax).
 *
 * We only add the SKU clause when the typed term looks like a SKU/code
 * (no spaces) — for normal multi-word searches this is skipped, so
 * everyday text search behaves exactly as before.
 *
 * The original typed text is preserved in a "display_q" param so the
 * search results page can show it back to the person instead of the
 * raw "term OR variants.sku:term" syntax. See main-search.liquid for
 * the matching template change.
 */
(function () {
  function enhanceForm(form) {
    if (form.dataset.skuSearchEnhanced) return;
    form.dataset.skuSearchEnhanced = "true";

    form.addEventListener("submit", function () {
      var qInput = form.querySelector('[name="q"]');
      if (!qInput) return;

      var term = qInput.value.trim();
      console.log(term)
      if (!term) return;

      // Preserve the exact text the person typed so we can show it back to them.
      var displayInput = form.querySelector('[name="display_q"]');
      if (!displayInput) {
        displayInput = document.createElement("input");
        displayInput.type = "hidden";
        displayInput.name = "display_q";
        form.appendChild(displayInput);
      }
      displayInput.value = term;

      // Only treat single-token, alphanumeric-ish strings as possible SKUs.
      // Adjust this pattern if your SKUs use other characters.
      var looksLikeSku = /^[A-Za-z0-9_-]+$/.test(term);

      if (looksLikeSku) {
        var escapedTerm = term.replace(/"/g, '\\"');
        // qInput.value = term + ' OR variants.sku:"' + escapedTerm + '"';
         qInput.value = term + ' OR variants.sku:"' + escapedTerm + '"';
        
      }
    });
  }

  function enhanceAll() {
    document
      .querySelectorAll("form.main-search__form, form.predictive-search__form, #predictive-search-form")
      .forEach(enhanceForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceAll);
  } else {
    enhanceAll();
  }

  // Re-run for forms added dynamically (e.g. drawer templates injected later).
  var observer = new MutationObserver(enhanceAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();